var map = {
	"./dpunkt.jpg": "0953",
	"./finanzbuch.png": "5ef5",
	"./hanser.png": "aa51",
	"./haufe.jpg": "c7ed",
	"./hermann-schmidt.png": "2131",
	"./mitp.png": "0457",
	"./murmann.png": "e9bb",
	"./oreilly.jpg": "7815",
	"./redline.png": "543f",
	"./rheinwerk.png": "47b2",
	"./wiley.jpg": "bc0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8cb";